<template lang="pug">
  .component-client-list-form
    .statuses
      .ml-3.status(v-for="status in ['ACTIVE','APPROVED','SUSPENDED','REFUSED','ON HOLD','PENDING REVIEW']")
        input(type="checkbox", v-model="search.status", :value="status")
        label {{status}}
    .row
      .columns.shrink(v-if =" $isNot('export-form')")
        a.fa.fa-search.fa-2x(@click="advanced = !advanced ")
      .basic.row(v-if="!advanced")
        .columns.ml-2.large-12
          date-range-picker(@input="dateRangeSelected")
      .advanced(v-if="advanced")
        .columns
          input-form(:fields="['query']", :placeholders="['Driver search']", @updatedData="setSearch")
      .columns.small-1.text-right(v-if="!advanced && $isNot('export-form')")
        a.fa.fa-filter.fa-2x(@click="setFilters")
</template>

<script>
import InputForm from './InputForm'
import DatePicker from '../../DatePicker'
import DateRangePicker from "../../DateRangePicker";

export default {
  name: 'DriverListForm',
  components: {DateRangePicker, DatePicker, InputForm},
  data() {
    return {
      advanced: false,
      search: {
        client_type: null,
        created_from: null,
        created_to: null,
        query: null,
        status: ['ACTIVE', 'SUSPENDED']
      }
    }
  },
  created() {
    this.setFilters()
  },
  methods: {
    setSearch(obj) {
      this.search = Object.assign({}, obj)
      this.$emit('setSearch', this.search)

    },
    setFilters() {
      this.search.query = null
      this.search.balance = null
      this.$emit('setSearch', this.search)
    },
    dateRangeSelected(range) {
      this.search.created_from = `${range.start} 00:00:00`
      this.search.created_to = `${range.end} 23:59:59`
    },

  },
  props: ['type'],
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-client-list-form
  .statuses
    display: flex

  .component-date-picker input
//padding: 0.7em

</style>



// WEBPACK FOOTER //
// DriverListForm.vue?0b609a0c